module.exports = __webpack_public_path__ + "img/together.d38dfdf7.png";